import React from 'react';
import PropTypes from 'prop-types';
import ArrowDownLogo from 'images/icons/arrow_down_white.png';
import ArrowUpLogo from 'images/icons/arrow_up_white.png';

class ReleaseListHeaderCell extends React.PureComponent {
	static propTypes = {
		name: PropTypes.string,
		clickable: PropTypes.string,
		sortedField: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
	}

	renderChevron = () => {
		const { clickable, sortedField } = this.props;
		if (clickable) {
			return (
				<img
					src={
						clickable === sortedField ? ArrowUpLogo : ArrowDownLogo
					}
					className="w-3 h-2 ml-2 select-none"
					alt="reorder" />
			);
		} else {
			return null;
		}
	}

	render() {
		const { name, clickable } = this.props;
		return (
			<div
				className={`flex flex-1 flex-row items-center min-w-0 ${
					clickable ? 'cursor-pointer' : ''
				}`}>
				<div className="text-center text-white font-header truncate select-none">
					{name}
				</div>
				{this.renderChevron()}
			</div>
		);
	}
}

export default ReleaseListHeaderCell;
